import React from 'react';
import { IconButton } from '@xo-union/tk-component-icons';
import styles from './styles.scss';

interface Props {
  disabled: boolean;
}

export const NextButton: React.FC<Props> = (props): JSX.Element => {
  if (props.disabled) {
    return <></>;
  }
  return (
    <IconButton
      aria-label="Next Hotel Rooms"
      name="caret_right"
      size="lg"
      {...props}
      data-testid="inspiration-carousel-next-btn"
      className={styles.hotelPlannerCarousel__nextButton}
    />
  );
};

export const PrevButton: React.FC<Props> = (props): JSX.Element => {
  if (props.disabled) {
    return <></>;
  }
  return (
    <IconButton
      aria-label="Previous Hotel Rooms"
      name="caret_left"
      size="lg"
      {...props}
      data-testid="inspiration-carousel-prev-btn"
      className={styles.hotelPlannerCarousel__nextButton}
    />
  );
};
